import restApi from "../../http.js";
import session from "../session";

export default class KeysApi {
  getClientKeys() {
    return restApi({
      method: "GET",
      url: "/keys/client",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
